<script setup lang="ts">

const props = withDefaults(defineProps<{
    message?: string
    info?: string
    onlyText?: boolean
}>(), {
    message: "Dit veld is verplicht",
    info: "",
    onlyText: false,
})
</script>

<template>
    <div :class="onlyText ? 'text-sm mt-1' : 'invalid-feedback'" class="d-block text-danger" role="alert">
        <span class="text-danger">
            {{ props.message }}
            <p v-if="props.info" class="text-gray-800 mt-1 mb-0" v-text="props.info" />
        </span>
    </div>
</template>
